var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMejakasir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 237,
    viewBox: "0 0 237 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2701_14384)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.388 236.669H46.2853C21.2745 236.669 1 216.396 1 191.384V46.2871C1 21.2727 21.2745 1 46.2853 1H191.388C216.398 1 236.673 21.2727 236.673 46.2871V191.384C236.673 216.396 216.398 236.669 191.388 236.669Z",
    fill: "#84C677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0221 186.5C59.0393 186.5 54.9353 182.441 55.63 177.507C56.3872 172.129 57.8222 166.857 59.9098 161.817C63.1512 153.991 67.9022 146.881 73.8916 140.892C79.881 134.902 86.9914 130.151 94.8169 126.91C102.642 123.668 111.03 122 119.5 122C127.97 122 136.358 123.668 144.183 126.91C152.009 130.151 159.119 134.902 165.108 140.892C171.098 146.881 175.849 153.991 179.09 161.817C181.178 166.857 182.613 172.129 183.37 177.507C184.065 182.441 179.961 186.5 174.978 186.5V186.5C169.995 186.5 166.044 182.424 165.083 177.535C164.49 174.523 163.6 171.571 162.42 168.722C160.085 163.086 156.663 157.965 152.349 153.651C148.035 149.337 142.914 145.915 137.278 143.58C131.642 141.246 125.601 140.044 119.5 140.044C113.399 140.044 107.358 141.246 101.722 143.58C96.0858 145.915 90.9646 149.337 86.6508 153.651C82.3369 157.965 78.915 163.086 76.5804 168.722C75.4003 171.571 74.5098 174.523 73.9175 177.534C72.9559 182.424 69.0048 186.5 64.0221 186.5V186.5Z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 112,
    width: 141,
    height: 19,
    rx: 9.5,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 70.5,
    r: 23.5,
    stroke: "white",
    strokeWidth: 20
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2701_14384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 237,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMejakasir);
export default __webpack_public_path__ + "static/media/logo-mejakasir.abf71e61a2fa84a52f1dc155f6c6c1b4.svg";
export { ForwardRef as ReactComponent };